/* eslint-disable import/no-extraneous-dependencies */
import React, {useState} from 'react';

import {Timeout} from './Timeout';
import {refreshTokenService, signOut, timeOut, sessionManagerRefreshToken} from './Util';
import {useSessionData} from './useSessionData';
import {ConCurrentSessionMonitor} from './ConCurrentSessionMonitor';
import {SessionExpiredAlertProps, ConCurrentContentProps} from './Types';

export const SessionExpiredAlert = (props: SessionExpiredAlertProps) => {
  const {
    headerContent,
    ohidRefreshTokenBeforeExpireIn,
    ohidSessionCheckInterval,
    inactiveTime,
    countdownTime,
    authProxyBaseURL
  } = props;

  const [isSessionRefresh, setIsSessionRefresh] = useState(() => crypto.randomUUID());
  const {isAuthV2, expireIn, sessionId, refreshToken} = useSessionData(isSessionRefresh);

  const refreshSession = async () => {
    if (isAuthV2 && sessionId) {
      await sessionManagerRefreshToken(expireIn, ohidRefreshTokenBeforeExpireIn, refreshToken);
      setIsSessionRefresh(crypto.randomUUID());
    } else {
      await refreshTokenService(authProxyBaseURL);
      setIsSessionRefresh(crypto.randomUUID());
    }
    document.body.classList.remove('modalOpen');
  };

  const conCurrentContent: ConCurrentContentProps = {
    sessionTerminatedLabel: headerContent?.sessionTerminatedLabel ?? '',
    sessionTerminatedMsg: headerContent?.sessionTerminatedMsg ?? '',
    okLabel: headerContent?.okLabel ?? ''
  };

  return (
    <div>
      <ConCurrentSessionMonitor content={conCurrentContent} />
      <Timeout
        inActiveTime={inactiveTime}
        countDownTime={countdownTime}
        loggedOut={!sessionId}
        closeError={signOut}
        timeOut={timeOut}
        staySignIn={refreshSession}
        refreshSession={refreshSession}
        expireIn={expireIn}
        isAuthV2={isAuthV2}
        content={headerContent}
        sessionCheckInterval={ohidSessionCheckInterval}
        tokenExpireThreshold={ohidRefreshTokenBeforeExpireIn}
      />
    </div>
  );
};
